/**
 * Mobile Grid Toggle
 * Switches between 1-column and 2-column product grid on mobile.
 * Persists the user's choice in localStorage.
 */
(function () {
  const STORAGE_KEY = 'moods-mobile-grid-columns';

  function init() {
    const toggleContainer = document.querySelector('.mobile-grid-toggle');
    if (!toggleContainer) return;

    const buttons = toggleContainer.querySelectorAll('.mobile-grid-toggle__btn');
    const productGrid = document.querySelector('.product-grid');
    if (!productGrid) return;

    // Restore saved preference
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === '1' || saved === '2') {
      applyGrid(productGrid, saved, buttons);
    }

    // Bind click events
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = this.getAttribute('data-grid-columns');
        applyGrid(productGrid, cols, buttons);
        localStorage.setItem(STORAGE_KEY, cols);
      });
    });
  }

  function applyGrid(grid, cols, buttons) {
    // Remove existing mobile column classes
    grid.classList.remove('product-grid--mobile-1-column', 'product-grid--mobile-2-column');
    // Add the selected one
    grid.classList.add('product-grid--mobile-' + cols + '-column');

    // Update active states
    buttons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-grid-columns') === cols;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
